<template>
    <b-modal
        id="edit-afn-params-modal"
        ref="edit-afn-params-modal"
        cancel-variant="outline-secondary"
        ok-title="Kaydet"
        cancel-title="Kapat"
        title="Amazon Gönderim Ayarları Düzenleme"
        size="lg"
        @ok="updateStore"
    >
        <validation-observer ref="simpleRules">
            <form @submit.prevent>
                <b-tabs
                    justified
                    pills
                >
                    <b-tab
                        v-if="store.afn_params"
                        title="Sabit Giderler"
                    >
                        <b-card-text>
                            <b-form-group
                                v-if="store.afn_params.commission !== undefined"
                                label-cols="4"
                                label="Sabit Komisyon (%)"
                                size="sm"
                            >
                                <validation-provider
                                    #default="{ errors }"
                                    name="commission"
                                    rules="required"
                                >
                                    <b-form-input
                                        v-model="store.afn_params.commission"
                                        type="number"
                                        size="sm"
                                        :state="errors.length > 0 ? false:null"
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group
                                v-if="store.afn_params.fixed_cost !== undefined"
                                label-cols="4"
                                label="Sabit Gider (₺)"
                                size="sm"
                            >
                                <b-form-input
                                    v-model="store.afn_params.fixed_cost"
                                    type="number"
                                    size="sm"
                                />
                            </b-form-group>
                        </b-card-text>
                    </b-tab>
                    <b-tab
                        v-if="store.afn_params && store.afn_params.scales"
                        title="Karlılık Baremleri"
                    >
                        <b-card-text>
                            <b-row>
                                <b-col cols="10">
                                    <b-input-group>
                                        <b-form-input
                                            type="text"
                                            value="Mak Alış"
                                            disabled
                                        />
                                        <b-form-input
                                            type="text"
                                            value="Min Kar"
                                            disabled
                                        />
                                        <b-form-input
                                            type="text"
                                            value="Mak Kar"
                                            disabled
                                        />
                                        <b-form-input
                                            type="text"
                                            value="Sabit Kar"
                                            disabled
                                        />
                                    </b-input-group>
                                </b-col>
                                <b-col cols="1">
                                    Yönetim
                                </b-col>
                            </b-row>
                            <Scale
                                v-for="(scale,index) in store.afn_params.scales"
                                :key="index"
                                :store-id="store.id"
                                :index="index"
                                :scale="scale"
                                :page="'afn'"
                            />
                            <b-row>
                                <b-col>
                                    <b-button
                                        size="sm"
                                        variant="success"
                                        @click="addScale"
                                    >Yeni Ekle
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-card-text>
                    </b-tab>
                    <b-tab
                        v-if="store.afn_params && store.afn_params.shipping_scales"
                        title="Kargo Baramleri"
                    >
                        <b-card-text>
                            <b-row>
                                <b-col cols="10">
                                    <b-input-group>
                                        <b-form-input
                                            type="text"
                                            value="Mak Satış"
                                            disabled
                                        />
                                        <b-form-input
                                            type="text"
                                            value="Fiyat"
                                            disabled
                                        />
                                    </b-input-group>
                                </b-col>
                                <b-col cols="1">
                                    Yönetim
                                </b-col>
                            </b-row>
                            <ShippingScale
                                v-for="(scale,index) in store.afn_params.shipping_scales"
                                :key="index"
                                :store-id="store.id"
                                :index="index"
                                :scale="scale"
                                :page="'afn'"
                            />
                            <b-row>
                                <b-col>
                                    <b-button
                                        size="sm"
                                        variant="success"
                                        @click="addShippingScale"
                                    >Yeni Ekle
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-card-text>
                    </b-tab>
                </b-tabs>
            </form>
        </validation-observer>
    </b-modal>
</template>

<script>

    import { mapGetters } from 'vuex'
    import Scale from '@/views/store/Scale'
    import ShippingScale from '@/views/store/ShippingScale'
    import draggable from 'vuedraggable'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import {
        required, email, confirmed, password,
    } from '@validations'
    import ToastificationContent from '@core/components/toastification/ToastificationContent'
    import DesiScale from '@/views/store/DesiScale'

    export default {
        name: 'EditAfnParams',
        components: {
            Scale, ShippingScale, draggable, ValidationProvider, ValidationObserver, DesiScale,
        },
        data: () => ({}),
        computed: {
            ...mapGetters('store', { store: '_selectedEditStore' }),
        },
        methods: {
            updateStore() {
                this.$refs.simpleRules.validate().then(success => {
                    if (success) {
                        this.$store.dispatch('store/edit', this.store)
                            .then(props => {
                                this.$toast({
                                    component: ToastificationContent,
                                    props,
                                })
                            })
                    }
                })
            },
            addScale() {
                this.$store.commit('store/addAfnScale', this.store.id)
            },
            addShippingScale() {
                this.$store.commit('store/addAfnShippingScale', this.store.id)
            },
        },
    }
</script>
